// Re-applies the site-wide DTC discount to PDP price blocks rendered by
// snippets/discounted-price-tags.liquid after theme.js updates the variant
// price text on selection change.
//
// theme.js's ProductForm.pushState() calls updateProductPrices() (which writes
// un-discounted variant.price into [data-product-price] / [data-compare-price])
// and then fireHookEvent() which dispatches `theme:variant:change` on the
// section container. We listen in capture phase (CustomEvent default
// bubbles=false) and rewrite the same elements with discounted markup.

(function () {
  if (!window.theme || !window.theme.settings) return;
  if (window.theme.settings.isB2bCustomer) return;

  var pct = parseFloat(window.theme.settings.siteDiscountPercentage) || 0;
  if (pct <= 0 || pct >= 100) return;

  function formatMoney(cents) {
    if (
      window.Shopify &&
      typeof window.Shopify.formatMoney === 'function' &&
      window.theme.moneyFormat
    ) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function decorate(scope, variant) {
    if (!scope || !variant || variant.price == null) return;
    var blocks = scope.querySelectorAll('[data-discount-price-block]');
    if (!blocks.length) return;

    var originalCents = variant.price;
    var discountedCents = Math.round((originalCents * (100 - pct)) / 100);

    blocks.forEach(function (block) {
      var priceEl = block.querySelector('[data-product-price]');
      var compareEl = block.querySelector('[data-compare-price]');
      var compareTextEl = block.querySelector('[data-compare-text]');
      if (!priceEl) return;

      priceEl.innerHTML = formatMoney(discountedCents);
      // theme.js may add the red sale class — site discount uses the standard
      // new-price color, not the red on-sale color.
      priceEl.classList.remove('product__price--sale');

      if (compareEl) {
        compareEl.innerHTML = formatMoney(originalCents);
        compareEl.classList.remove('hidden');
      }
      if (compareTextEl) {
        compareTextEl.classList.remove('hidden');
      }
    });
  }

  document.addEventListener(
    'theme:variant:change',
    function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      decorate(event.target, variant);
    },
    true
  );
})();
